import { AxiosResponse } from 'axios';

import { api } from '../../http';
import { FileConfiguration } from '../../types/interfaces/FileConfiguration';

export const AttachmentService = {
  getByTask(id: number): Promise<AxiosResponse<any | undefined>> {
    return api.get<any | undefined>('attachment/getByTask?id=' + id);
  },
  get(id: number): Promise<AxiosResponse<Blob>> {
    return api.get<Blob>('attachment/' + id, {
      responseType: 'blob'
    });
  },
  add(formData: FormData): Promise<AxiosResponse<number | undefined>> {
    return api.post<any | undefined>('attachment/', formData, {
      headers: { 'content-type': 'multipart/form-data' }
    });
  },
  delete(id: number): Promise<AxiosResponse> {
    return api.delete('attachment/' + id);
  },
  getAttachmentConfiguration(): Promise<
    AxiosResponse<FileConfiguration | undefined>
  > {
    return api.get<FileConfiguration | undefined>(
      'attachment/getAttachmentConfiguration'
    );
  }
};
